import React from 'react';
import { ChevronLeft, ChevronRight, CalendarDays, RefreshCw } from 'lucide-react';
import { istDayKey } from '../../utils/dates';

/**
 * The board's single control. Every column is a question asked "as of" this date, so moving it
 * re-runs the whole board — which is how the same board answers "who do I chase today" and "who
 * will I need to chase tomorrow".
 */
export default function AnchorDateBar({ anchor, setAnchor, isFetching, onRefresh }) {
  const today = istDayKey(new Date());
  const shift = (days) => {
    const d = new Date(`${anchor}T00:00:00`);
    d.setDate(d.getDate() + days);
    setAnchor(istDayKey(d));
  };

  return (
    <div className="toolbar anchor-bar">
      <CalendarDays size={16} className="td-muted" />
      <span className="anchor-label">Board date</span>

      <button className="btn-icon-sm" title="Previous day" onClick={() => shift(-1)}>
        <ChevronLeft size={16} />
      </button>
      <input
        type="date"
        className="form-control"
        style={{ width: 160 }}
        value={anchor}
        onChange={(e) => setAnchor(e.target.value || today)}
      />
      <button className="btn-icon-sm" title="Next day" onClick={() => shift(1)}>
        <ChevronRight size={16} />
      </button>

      {anchor !== today && (
        <button className="btn btn-outline btn-sm" onClick={() => setAnchor(today)}>Today</button>
      )}

      <span className="td-muted anchor-hint">
        {anchor === today
          ? 'Every column is answering “as of today”.'
          : 'Every column is answering “as of this date”.'}
      </span>

      <button className="btn btn-outline btn-sm" style={{ marginLeft: 'auto' }} onClick={onRefresh} title="Refresh now">
        <RefreshCw size={14} className={isFetching ? 'spin' : ''} /> Refresh
      </button>
    </div>
  );
}
